import React, { Component } from "react";
import PropTypes from "prop-types";

import { debounce } from "lodash";
import moment from "moment";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input, Textarea } from "formsy-react-components";
import CurrencyInput from "../../common/CurrencyInput";

import { formatDate } from "../../../helpers/date";

class PurchaseOrderForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      canSubmit: false,
      changed_rate: false
    };
  }

  onChange = debounce((field, value) => {
    const { contract, purchaseOrder } = this.props;
    const newValue = parseFloat(value.replace(/[$,]+/g, ""));

    if (field === "billing_rate") {
      this.setState({ changed_rate: true });
    }

    this.setState({ [field]: newValue }, () => {
      const billing_rate =
        this.state.billing_rate ||
        purchaseOrder.billing_rate ||
        contract.billing_rate;
      const hours_purchased =
        this.state.hours_purchased || purchaseOrder.hours_purchased;
      if (field === "hours_purchased" && billing_rate) {
        const amount = billing_rate * parseFloat(newValue);
        this.setState({ amount });
      } else if (field === "billing_rate" && hours_purchased) {
        const rate = newValue;
        const amount = hours_purchased * parseFloat(rate);
        this.setState({ amount });
      }
    });
  }, 500);

  add = (model) => {
    const data = { ...model };
    if (data.invoice_date) {
      data.invoice_date = moment(data.invoice_date).toDate();
    }
    this.props.onAdd(this.props.contract, data);
  };

  submit = (model) => {
    const data = { ...model };
    if (data.invoice_date) {
      data.invoice_date = moment(data.invoice_date).toDate();
    }
    this.props.onSave(this.props.contract, data);
  };

  cancel = () => {
    this.props.onCancel();
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  render() {
    const { contract, purchaseOrder, adding } = this.props;

    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          {/* {!adding && (       */}
          <Col md={4} xs={6}>
            <Input
              formNoValidate
              required
              name="invoice_number"
              label="Invoice Number"
              value={purchaseOrder.invoice_number}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          {/* )}   */}
          <Col md={4} xs={6}>
            <Input
              type="date"
              formNoValidate
              required
              name="invoice_date"
              label="Invoice Date"
              value={
                purchaseOrder.invoice_date
                  ? formatDate(purchaseOrder.invoice_date, "yyyy-MM-dd")
                  : ""
              }
            />
          </Col>
          <Col md={4} xs={6}>
            <Input
              formNoValidate
              name="po_number"
              label="PO Number"
              value={purchaseOrder.po_number}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={4} xs={6}>
            <CurrencyInput
              required
              type="number"
              name="billing_rate"
              label="Billing Rate"
              onChange={(e) => this.onChange("billing_rate", e.target.value)}
              value={
                adding
                  ? contract.billing_rate
                  : this.state.billing_rate || purchaseOrder.billing_rate
              }
            />
          </Col>
          <Col md={4} xs={6}>
            <Input
              type="number"
              formNoValidate
              required
              onChange={this.onChange}
              name="hours_purchased"
              label="Hours Purchased"
              value={
                this.state.hours_purchased || purchaseOrder.hours_purchased
              }
            />
          </Col>
          <Col md={4} xs={6}>
            <CurrencyInput
              required
              readOnly
              type="number"
              name="amount"
              label="Amount"
              value={this.state.amount || purchaseOrder.amount}
            />
          </Col>
          <Col md={12} xs={12}>
            <Textarea
              formNoValidate
              name="notes"
              label="Note"
              value={purchaseOrder.notes}
              validations={{ maxLength: 250 }}
              validationErrors={{
                maxLength: "You can not type in more than 250 characters"
              }}
            />
          </Col>
          {this.state.changed_rate && (
            <Col md={12} xs={12} style={{ marginTop: "10px" }}>
              <div>
                <span>
                  Click <strong>Save and Update Contract</strong> to set
                  Contract Billing Rate to{" "}
                  <strong>${this.state.billing_rate}</strong> for all new
                  purchases and projects for this contract.
                </span>
              </div>
            </Col>
          )}
          <Col md={12} xs={12} className="footer">
            <button
              type="button"
              className="btn  btn-cancel"
              onClick={this.cancel}
            >
              Cancel
            </button>
            <input
              className="btn btn-success"
              type="submit"
              disabled={!this.state.canSubmit || this.props.saving}
              value={this.props.saving ? "Saving... " : "Save"}
            />
            {this.state.changed_rate && (
              <input
                className="btn btn-success"
                type="submit"
                disabled={!this.state.canSubmit || this.props.saving}
                value={
                  this.props.saving ? "Saving... " : "Save and Update Contract"
                }
              />
            )}
          </Col>
        </Row>
      </Formsy>
    );
  }
}

PurchaseOrderForm.propTypes = {
  purchaseOrder: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  contract: PropTypes.object,
  onAdd: PropTypes.func,
  adding: PropTypes.bool
};

export default PurchaseOrderForm;
